import useLocalization from '@app/hooks/useLocalization'
import { IToiletTypes } from '@app/interfaces/organization-passport/toilet-types'
import { sortByName } from '@app/utils/sort-by-name/sort-by-name'
import { Form, Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface props {
  toiletTypes: IToiletTypes[]
}

const ToiletTypesItem: React.FC<props> = ({ toiletTypes }) => {
  const [t] = useTranslation()
  const { localize } = useLocalization()
  return (
    <>
      <Form.Item label={t('toiletType.toiletType')} name={'toiletType'}>
        <Select placeholder={t('institutionPlaceholders.toiletType')}>
          {sortByName(localize(toiletTypes)).map((toiletType, index) => {
            if (toiletType.status) {
              return (
                <Select.Option key={index} value={toiletType.id!.toString()}>
                  {toiletType?.data?.name}
                </Select.Option>
              )
            }
            return null
          })}
        </Select>
      </Form.Item>
    </>
  )
}

export default ToiletTypesItem
